import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../auth/auth.service';
import {CurrentUser, CurrentUserService} from '../../services/current-user.service';

@Component({
  selector: 'app-popover-menu',
  templateUrl: './popover-menu.component.html',
  styleUrl: './popover-menu.component.css',
  standalone: false
})
export class PopoverMenuComponent implements OnInit {

  currentUser: CurrentUser | null = null;

  constructor(
    private authService: AuthService,
    private currentUserService: CurrentUserService
  ) {}

  ngOnInit(): void {
    this.currentUserService.getCurrentUser().subscribe(user => {
      this.currentUser = user;
    });
  }

  get initials(): string {
    if (!this.currentUser) return '?';
    const first = this.currentUser.firstName?.[0] ?? '';
    const last = this.currentUser.lastName?.[0] ?? '';
    return (first + last).toUpperCase() || this.currentUser.userName?.[0]?.toUpperCase() || '?';
  }

  get profileUrl(): string {
    return this.authService.authentikProfileUrl;
  }

  logout(): void {
    this.authService.logout();
  }
}
